import { DashboardSlaSlot } from "@redotech/redo-fulfillment-operations-common/views/default-outbound-views";
import { viewSchemas } from "@redotech/redo-views-common/views";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getDashboardSlaViews = {
  name: "getDashboardSlaViews" as const,
  input: z.object({
    merchantTimezone: z.string().nullish(),
    includeCounts: z.boolean().optional(),
    locationId: z.string().nullish(),
    slots: z.array(createEnum(DashboardSlaSlot)).optional(),
  }),
  output: z.object({
    slots: z.array(
      z.object({
        slot: createEnum(DashboardSlaSlot),
        view: viewSchemas["fulfillment-groups"],
        customized: z.boolean(),
        count: z.number().nullable(),
        itemCount: z.number().nullable(),
      }),
    ),
  }),
};
